<template>
    <div id="equipment-container">
        <label class="label">Equipment</label>
        <div class="field is-grouped is-grouped-multiline">
            <div class="control" v-for="(name, index) in names" :key="index">
                <label class="checkbox">
                    <input type="checkbox"
                           :checked="checkEquipment(name)"
                           @click="handleEquipment(name)">
                    {{ name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                names: ['AC', 'AW', 'LE', 'SR', 'PW', 'PS', 'TV', 'WAC', 'R', 'RA']
            }
        },
        methods: {
            checkEquipment: function (equipment) {
                return this.$store.getters.getQueryEquipmentStatus(equipment)
            },
            handleEquipment: function (equipment) {
                this.$store.dispatch('handleQueryEquipment', equipment)
            }
        }
    }
</script>

<style scoped>
    #equipment-container {
        margin-top: 10px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/SpecificationEquipment.vue